import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { CustomPaginationContainer } from './customPagination.style';

const CustomPagination = ({ baseUrl, currentPage, totalPages, sectionId }) => {
  const [activePage, setActivePage] = useState(1);
  const [activePageRes, setActivePageRes] = useState(0);

  useEffect(() => {
    setActivePage(currentPage);
    setActivePageRes(currentPage - 1);
  }, [currentPage]);

  const pageLimitRes = 3;
  let pages = [];
  let responsivePages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
    responsivePages.push(i);
  }
  const lastPage = pages.length;

  const changeActivePage = (pageNumber) => {
    setActivePage(pageNumber);
    setActivePageRes(pageNumber);
  };

  // for mobile view
  const getDisplayedPages = () => {
    let start = activePageRes - Math.floor(pageLimitRes / 2);
    let end = activePageRes + Math.floor(pageLimitRes / 2);

    if (start < 1) {
      start = 1;
      end = pageLimitRes;
    }

    if (end > totalPages) {
      end = totalPages;
      start = totalPages - pageLimitRes + 1;
      if (start < 1) {
        start = 1;
      }
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  let showPagesRes = getDisplayedPages();
  let lastIndexPage = showPagesRes[showPagesRes.length - 1];
  let firstIndexPage = showPagesRes[0];

  return (
    <div data-testid='pagination-container' id='pagination'>
      <CustomPaginationContainer className='for-desktop'>
        <li>
          {currentPage <= 2 ? (
            <Link
              to={`${baseUrl}${sectionId ? sectionId : ''}`}
              className={currentPage === 1 ? 'disabled' : null}
              onClick={() => changeActivePage(currentPage - 1)}
              title='Previous'
            >
              <FiChevronLeft />
            </Link>
          ) : (
            <Link
              to={`${baseUrl}${currentPage - 1}/${sectionId ? sectionId : ''}`}
              className={currentPage === 1 ? 'disabled' : null}
              onClick={() => changeActivePage(currentPage - 1)}
              rel='nofollow'
              title='Previous'
            >
              <FiChevronLeft />
            </Link>
          )}
        </li>

        {pages.map((pageNumber) => {
          if (totalPages <= 5) {
            return (
              <li key={pageNumber}>
                <Link
                  to={`${baseUrl}${
                    pageNumber === 1
                      ? sectionId
                        ? sectionId
                        : ''
                      : `${pageNumber}/${sectionId ? sectionId : ''}`
                  }`}
                  className={currentPage === pageNumber ? 'active' : null}
                  onClick={() => changeActivePage(pageNumber)}
                  rel='nofollow'
                  title={pageNumber}
                >
                  {pageNumber}
                </Link>
              </li>
            );
          } else {
            if (pageNumber === 1 || pageNumber === lastPage) {
              return (
                <li key={pageNumber}>
                  <Link
                    to={`${baseUrl}${
                      pageNumber === 1
                        ? sectionId
                          ? sectionId
                          : ''
                        : `${pageNumber}/${sectionId ? sectionId : ''}`
                    }`}
                    className={currentPage === pageNumber ? 'active' : null}
                    onClick={() => changeActivePage(pageNumber)}
                    rel='nofollow'
                    title={pageNumber}
                  >
                    {pageNumber}
                  </Link>
                </li>
              );
            } else if (
              pageNumber === activePage ||
              pageNumber === activePage - 1 ||
              pageNumber === activePage + 1
            ) {
              return (
                <li key={pageNumber}>
                  <Link
                    to={`${baseUrl}${
                      pageNumber === 1
                        ? sectionId
                          ? sectionId
                          : ''
                        : `${pageNumber}/${sectionId ? sectionId : ''}`
                    }`}
                    className={currentPage === pageNumber ? 'active' : null}
                    onClick={() => changeActivePage(pageNumber)}
                    rel='nofollow'
                    title={pageNumber}
                  >
                    {pageNumber}
                  </Link>
                </li>
              );
            } else if (
              pageNumber === activePage - 2 ||
              pageNumber === activePage + 2
            ) {
              return (
                <li
                  key={pageNumber}
                  onClick={() => changeActivePage(pageNumber)}
                >
                  <span>...</span>
                </li>
              );
            }
          }
        })}
        <li>
          <Link
            to={`${baseUrl}${currentPage + 1}/${sectionId ? sectionId : ''}`}
            className={currentPage === lastPage ? 'disabled' : null}
            onClick={() => changeActivePage(currentPage + 1)}
            data-testid='nextBtn'
            rel='nofollow'
            title='Next'
          >
            <FiChevronRight />
          </Link>
        </li>
      </CustomPaginationContainer>
      {/*For Responsive pagination */}
      <CustomPaginationContainer className='for-mobile'>
        <li>
          <span
            onClick={() => setActivePageRes(firstIndexPage - 2)}
            className={firstIndexPage === 1 ? 'disabled' : null}
            title='Previous'
          >
            <FiChevronLeft />
          </span>
        </li>
        {showPagesRes.map((number) => {
          return (
            <li key={number}>
              <Link
                to={`${baseUrl}${
                  number === 1
                    ? sectionId
                      ? sectionId
                      : ''
                    : `${number}/${sectionId ? sectionId : ''}`
                }`}
                className={currentPage === number ? 'active' : null}
                rel='nofollow'
                title={number}
              >
                {number}
              </Link>
            </li>
          );
        })}
        <li>
          <span
            onClick={() => setActivePageRes(lastIndexPage + 2)}
            className={lastIndexPage === lastPage ? 'disabled' : null}
            title='Next'
          >
            <FiChevronRight />
          </span>
        </li>
      </CustomPaginationContainer>
    </div>
  );
};

export default CustomPagination;
